$(document).ready(function(){
  console.log('Cart timer and bar');

  setInterval(function(){
     jQuery.getJSON("/cart.js", function (cart) {
        console.log(cart);
       var totalPrice = cart.total_price;
       var treshold = 6900;
       

       var likutis = treshold - totalPrice;

       // console.log(likutis);
       if (likutis > 0){

         var percent = 0;
         percent = 100 - (likutis * 100 / treshold);
         likutis = (likutis/100).toFixed(2);
         $('.hcd_progress_title_before span').html(likutis + '€');
           
            $('.hcd_progress_title_after').hide();
            $('.hcd_progress_title_before').show();
            $('.hcd_progress_in').css('width', percent+'%');
         }
         else{
           $('.hcd_progress_title_after').show();
           $('.hcd_progress_title_before').hide();
           $('.hcd_progress_in').css('width', '100%');
         }


       // Subtotal price compilation

       var itemsComparePrice = 0;
       for (var i = 0; i < cart.items.length; i++) {
         var itemHasCompare = 0;
         $('.cart_items_checker').each(function(){
           if (cart.items[i].id == $(this).attr('data-id')){
             itemsComparePrice = itemsComparePrice + cart.items[i].quantity * parseFloat($(this).attr('data-compare'));
             itemHasCompare = 1;
           }
         });

         if (itemHasCompare == 0){
           itemsComparePrice = itemsComparePrice + cart.items[i].original_line_price;
         }
       }

       var cartComparePrice = cart.total_price;
       if (cartComparePrice == itemsComparePrice){
         $('.comparingCartTotalPrices').hide();
       }
       else{
         $('.comparingCartTotalPrices').css('display', 'flex');
       }

         // console.log(itemsComparePrice, cartComparePrice, 'comparing prices')
       var sutaupotePrice = itemsComparePrice - cart.total_price ;
       sutaupotePrice= (sutaupotePrice/100).toFixed(2);
       sutaupotePrice = sutaupotePrice.replace('.', ',');
       $('.csapps-cart-original-total.total_compare_pricing').html(sutaupotePrice+ '€');

       
       // console.log(itemsComparePrice, 'compare');
     });
  },500);
});